/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Card, IconButton, Grid, Box } from '@mui/material';
import { DragHandle, Visibility, VisibilityOff } from '@opengeoweb/theme';

export const SoundingManagerListItem = ({
  id,
  name,
  isDisplayed,
  onToggleVisibility,
}: {
  id: string;
  name: string;
  isDisplayed: boolean;
  onToggleVisibility: (id: string) => void;
}): React.ReactElement => {
  return (
    <Card
      className="sortable-item"
      sx={{
        margin: '4px 0 2px',
        backgroundColor: isDisplayed ? 'white' : 'rgb(232, 232, 232)',
      }}
    >
      <Grid
        alignItems="center"
        container
        direction="row"
        justifyContent="flex-start"
        sx={{ height: '32px' }}
      >
        <IconButton
          aria-label="drag-handle"
          className="drag-handle"
          size="small"
          sx={{
            width: '24px',
            height: '24px',
            paddingRight: '8px',
            paddingLeft: '8px',
          }}
        >
          <DragHandle fontSize="small" />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            aria-label="toggle-visibility"
            onClick={() => onToggleVisibility(id)}
            size="small"
            sx={{
              width: '24px',
              height: '24px',
            }}
          >
            {isDisplayed ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </Box>
        <Box sx={{ paddingRight: '8px', paddingLeft: '8px' }}> {name} </Box>
      </Grid>
    </Card>
  );
};
